import Vue from "vue";
import getGhostQuery from "@/graphql/getGhostQuery"
import {
    mapState
} from 'vuex'
import {
    Card,
    Button,
    FormGroupInput,
    Checkbox,
    Pagination
} from '@/components'
import {
    Switch,
    Radio
} from 'element-ui'
export default {
    data() {
        return {
            formstate: {},
            averaged: false,
            checked: false,
            type: "1",
            height: 640,
            smallScreen: window.innerWidth < 620 ? true : false,
            scale: !this.smallScreen ? 1 : window.innerWidth / 620 < 0.8 ? window.innerWidth / 620 + 0.1 : 0.9,
            output: '',
            sample: '',
            usePercentages: false,
            percentages: {},
            suspend: false,
            public: 0,
            saving: false,
            model: {},
            ghostSample: [],
            generation: {
                1: 0
            },
            options: {
                mousewheel: false,
                cssMode: true,
                simulateTouch: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                }
            },
            ancestor: {},
            generations: {
                "1": "Parent",
                "2": "Grand Parent",
                "3": "Great Grand Parent"
            },
            ancestors: [{
                index: 0,
                generation: 2,
                pct: 100,
            }],
            groupSamples: true,
            groupJSON: [],
            sampleJSON: [],
            baseArray: []
        }
    },
    computed: {
        ...mapState({
            onLine: 'onLine',
            geo: 'geo',
            fadeIn: 'fadeIn',
            isAdmin: 'isAdmin',
            activePane: 'activePane',
            primaryT: 'primaryTabs',
            secondaryT: 'secondaryTabs',
            lastQuery: 'lastQuery',
            firstRun: 'g25firstRun',
            subs: 'subscription',
            loading: 'g25chartLoading',
            statusMessage: 'statusMessage',
            running: 'g25chartRunning',
            series: 'g25chartSeries',
            showGrid: 'showGrid',
            userSamples: 'userSamples',
            colors: 'g25chartColors',
            chartJSON: 'g25chartJSON',
            categories: 'g25chartCategories',
            chartKey: 'g25chartKey',
            slider: 'slider',
            testData: 'testData',
            user: 'user',
            lastSort: 'lastSort',
            switches: 'switches'
        }),
        mode: {
        set: function(value) {
        this.$store.commit('change', {monteMode: value})
        },
        get: function(value) {
        return this.$store.getters.get('monteMode') ? this.$store.getters.get('monteMode') : 'G25'
        }
        },
        groupSelect: function() {
            return true
        },
        append: function()  {
            let pct = this.usePercentages && this.ancestors.filter( x => x.pct == undefined || isNaN(x.pct) ).length > 0 ? true : false
            let append = this.suspend ? false : this.type !== '3' && this.baseArray[0] && this.ancestors[this.ancestors.length - 1].sample && this.ancestors[this.ancestors.length - 1].sample[0] && !pct ? true :  this.type == '3' && this.ancestors[this.ancestors.length - 1].sample && this.ancestors[this.ancestors.length - 1].sample[0] ? true : false
            return append;
            },
        groupOptions: function() {
            if (!this.groupSamples) {
                if ( this.mode === 'G25' ) {
                return this.groupJSON.filter( x => x.type === 'G25' || x.type === undefined )
                } else {
                return this.groupJSON.filter( x => x.type !== 'G25' && x.type !== undefined )
                }
            } else {
                var newoptions = []
                var array = JSON.parse(JSON.stringify(this.sampleJSON))
                array.forEach(group => {
                    group.samples.forEach(sample => {
                        if ((sample.mode === 'raw' || sample.mode === this.mode || sample.type === this.mode) && (sample.public !== 0 || sample.type !== 'user')) {
                            sample.label = sample.group + " ► " + sample.sample
                            delete sample.coords;
                            delete sample.coords2;
                            newoptions.push(sample)
                        }
                    })
                })
                return newoptions
            }
        },
        sampleOptions: function() {
                var newoptions = []
                var array = JSON.parse(JSON.stringify(this.sampleJSON))
                array.forEach(group => {
                    group.samples.forEach(sample => {
                        if ((sample.mode === 'raw' || sample.mode === this.mode || sample.type === this.mode) && (sample.public !== 0 || sample.type !== 'user')) {
                            sample.label = sample.group + " ► " + sample.sample
                            delete sample.coords;
                            delete sample.coords2;
                            newoptions.push(sample)
                        }
                    })
                })
                return newoptions
        },
        savable: function() {
            //this.append = this.type !== '3' && !pct  ? this.append : this.usePercentages && this.ancestors.filter( x => x.pct == undefined || isNaN(x.pct) ).length > 0 ? false : this.type === '3' && this.ancestors[this.ancestors.length - 1].sample ? true : this.append
            let savable  = ((this.type === '2' && !this.formstate.$invalid && this.append && this.baseArray.length > 0 && this.ancestors[0].sample && this.ancestors[0].generation && this.model.sample) || (this.type === '1' && !this.formstate.$invalid && this.append && this.baseArray.length > 0 && this.ancestors[this.ancestors.length - 1].sample && this.ancestors[this.ancestors.length - 1].generation && this.model.sample) || (this.type === '3' && !this.formstate.$invalid && this.append && this.ancestors[this.ancestors.length - 1].sample && this.ancestors.length >= 1 && this.model.sample))
            return savable
        },
        initData: function() {
            var data = JSON.parse(JSON.stringify(this.$store.getters.get("editSamples")));
            return data;
        },
        changes: function() {
            return this.$store.getters.get('changes')
        },
        displayResults: function() {
        this.height = this.$refs.ghostresults ? this.$refs.ghostresults.clientHeight : 0
        if ( this.type === '3' ) {
            if (this.ancestors.length > 0 && this.ancestors[0].sample && this.ancestors[0].sample.length > 0) {
                let results = {}
                let addedAncestry = 0;
                this.ancestors[0].sample.map(ancestor => {
                    if (ancestor.label) {
                        let length = this.ancestors[0].sample.filter( x => x.sample !== undefined) .length
                        let pct = parseFloat((100 / length).toFixed(5))
                        addedAncestry = addedAncestry + ( pct ? pct : 0 )
                        results[ancestor.label] = pct
                    }
                })
                let outArr = []
                Object.keys(results).map(key => {
                    let obj = {}
                    obj.sample = key.replace(/ ► /g, ':')
                    obj.pct = results[key] 
                    if (obj.pct > 0) outArr.push(obj)
                })
                    this.ghostSample = outArr;
                    let output = 'Averaging: ['
                    outArr.map( (result, index) => {
                    if ( result.pct ) {
                    output = index === 0 ? `${output} ${parseFloat(result.pct.toFixed(2))}% ${result.sample.replace(/:/, ' ► ')}` : `${output}, ${parseFloat(result.pct.toFixed(2))}% ${result.sample.replace(/:/, ' ► ')}`;
                    }
                    })
                this.description = output.replace(/_/g, ' ').replace(/:/g, ' ► ') + ' ]'
                return this.description
                }
        } else {
            if (this.ancestors.length > 0 && this.baseArray[0] && this.baseArray[0][0] && this.ancestors[0].sample && this.ancestors[0].sample.length > 0) {
                let results = {}
                let addedAncestry = 0;
                this.ancestors.map(ancestor => {
                    if (ancestor.sample && ancestor.sample[0] && ancestor.sample[0].label) {
                        let pct = this.usePercentages ? ancestor.pct  : 100 * Math.pow(2, -1 * ancestor.generation)
                        addedAncestry = addedAncestry + ( pct ? pct : 0 )
                        results[ancestor.sample[0].label] = results[ancestor.sample[0].label] ? results[ancestor.sample[0].label] + ( pct ? pct: 0 ) : pct
                    }
                })
                if (addedAncestry > 100) {
                    let message;
                    if ( this.type === '2' ) {
                    message = "You appear to have selected too many ancestors. Sum of all ancestries cannot exceed 100%"
                    } else {
                    message = "You appear to have selected too many ancestors. Sum of all ancestries cannot exceed 100%"
                    }
                    this.suspend = true;
                    return message
                } else {
                    this.suspend = false
                }
                results[this.baseArray[0][0].label] = results[this.baseArray[0][0].label] ? results[this.baseArray[0][0].label] + 100 - addedAncestry : 100 - addedAncestry
                let outArr = []
                Object.keys(results).map(key => {
                    let obj = {}
                    obj.sample = key.replace(/ ► /g, ':')
                    obj.pct = results[key] 
                    if (obj.pct > 0) outArr.push(obj)
                })
                if ( this.type === '1' ) outArr.sort((a, b) => a.pct > b.pct ? -1 : 1)
                if ( this.type === '2' ) outArr.sort( x => x.sample === this.baseArray[0][0].label.replace(/ ► /g, ':') ? -1 : 1 )
                this.ghostSample = outArr
                let output = this.type === '2' ? 'Ghost: subtracting [' : ""
                let resultArr = this.type === '2' ? outArr.filter( x => x.sample != this.baseArray[0][0].label.replace(/ ► /g, ':') ) : outArr
                let total = this.type === '2' && resultArr.length > 1 && resultArr.filter(x => x.pct && !isNaN(x.pct)).length === resultArr.length ?  resultArr.reduce( (a,b) => b.pct + ( a.pct ? a.pct : a ) ) + '% ' : ''
                resultArr.map((result, index) => {
                    if ( this.type === '2' ) {
                    output = index == 0 ? `Ghost: subtracting ${total}[ ${parseFloat(result.pct.toFixed(4))}% ${result.sample}` : `${output}, ${parseFloat(result.pct.toFixed(4))}% ${result.sample}`
                    } else {
                    output = index === 0 ? `${output} ${parseFloat(result.pct.toFixed(4))}% ${result.sample}` : `${output}, ${parseFloat(result.pct.toFixed(4))}% ${result.sample}`;
                    }
                })
                output = this.type === '2' ? output + ' ]' : output
                this.description = output.replace(/_/g, ' ').replace(/:/g, ' ► ')
                return this.description
            } else if (this.baseArray[0] && this.baseArray[0][0] && this.baseArray[0][0].label) {
                return `100% ${this.baseArray[0][0].label.replace(/_/g, ' ').replace(/:/g, ' ► ')}`
            } else {
                return ""
            }
            }
        },
        samplesReady: function(evt) {
            if (this.baseArray && this.baseArray.length > 1) {
                return true
            } else {
                return false
            }
        },
    },
    mounted: function() {
        this.ancestors = [{
            generation: 2,
            index: 0
        }]
    },
    methods: {
        selectSearchText(ref) {
            if ( this.averaged && this.$refs[ref] ) {
            let el = this.$refs[ref][0] ? this.$refs[ref][0] : this.$refs[ref]
            el.$refs.search.focus()
            el.$refs.search.select()
            }
        },
        log: function(evt) {
            console.log(evt)
        },
        setPCT: function(val,index) {
        if ( val && val.target && val.target.value && !isNaN(parseFloat(val.target.value)) ) {
        this.ancestors[index].pct = parseFloat(val.target.value)
        }
        },
        syncAveraged: function(evt) {
        this.averaged = false 
        if ( this.ancestors[0] && this.ancestors[0].sample && this.ancestors[0].sample[0] && ( evt ==  '1' || evt == '2' )) {
        this.ancestors[0].sample = [this.ancestors[0].sample[0]]
        }
        if ( evt === '2' ) {
        this.ancestors[0].generation = 1;
        this.ancestors[0].pct = this.ancestors[0].pct === undefined || isNaN(parseFloat(this.ancestors[0].pct))  ? 1 : this.ancestors[0].pct
        this.averaged = false 
        } else {
        if ( evt === '3' ) {
        this.baseArray = [];
        if ( this.ancestors.length > 1) {
        this.ancestors = [this.ancestors[0]]
        }
        this.averaged = true 
        this.groupSamples = true
        }
        }
        },
        getGhost: function() {
            var w = this;
            this.ghostSample.map( x => {
            let sample;
            if ( x.sample.split(':').length > 1 ) {
            sample = this.sampleOptions.find( sample => sample.index === x.sample || sample.label === x.sample )
            } else {
            sample = this.groupOptions.find( sample => sample.index === x.sample || sample.label === x.sample )
            }
            let label = sample.index ? 'index' : 'label'
            x.sample = sample && sample.v ? ( sample[label].split(':')[1] ?  sample[label].split(':')[0] + '|' +  sample.v + ':' + sample[label].split(':')[1] : sample[label] + '|' + sample.v ) : x.sample;
            x.sample = sample && w.mode !== 'G25' ? ( sample[label].split(':')[1] ?  sample[label].split(':')[0] + '|' +  w.mode + ':' + sample[label].split(':')[1] : sample[label] + '|' + w.mode ) : x.sample;
            })
            var params = {
                id: this.user.username + ':ghost:' + Date.now(),
                subId: this.user.username,
                sample: this.user.username,
                groups: this.ghostSample,
                raw: this.mode !== 'G25' && this.mode.substr(0,6) !== 'GENO25' ? true : false,
                subtract: this.type === '2',
                generation: this.type === '2' ? this.ancestors[0].generation : false,
                averaged: this.type === '3' ? true : undefined
            }
            w.$apollo.query({
                    query: getGhostQuery,
                    variables: {
                        params: JSON.stringify(params)
                    }
                })
                .then(data => {
                    if (data.data && data.data.getGhost && data.data.getGhost.result) {
                        let coords = JSON.parse(data.data.getGhost.result).scaled.join(',')
                        let coords2 = JSON.parse(data.data.getGhost.result).unscaled.join(',')
                        let model = {
                            age: new Date().getFullYear(),
                            class: 'default user',
                            ethnicity: 'ghost',
                            origin: 'ghost',
                            group: this.user.username,
                            sample: this.model.sample,
                            type: this.model.type ? this.model.type : this.mode,
                            description: this.description + " (ghost)",
                            coords: coords,
                            coords2: coords2,
                            public: this.public
                        }

                        var data = JSON.parse(JSON.stringify(this.$store.getters.get("editSamples")));
                        var index = data.length;
                        model.index = index;
                        model.action = 'insert'
                        data.push(model);
                        var changes = {
                            ...this.changes
                        }
                        changes[model.sample] = model
                        this.$store.commit('change', {
                            changes: changes
                        })
                        this.$store.commit('change', {
                            editSamples: data
                        })
                        this.saving = false;

                        this.closeModal(true);
                    } else {
                        console.log('ghost not found', data)
                        this.saving = false;
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        setTag: function(query, id) {
            console.log(query, id)
        },
        save: function() {
            this.saving = true;
            this.getGhost();
        },
        closeModal: function(flag) {
            var closable = flag ? flag : false
            if (this.append && !closable) {
                this.show({
                    title: 'Are you sure?',
                    text: 'You have unsaved changes, these will be lost if you continue.',
                    class: 'warning'
                });
                return;
            } else {
                this.closable = true;
                this.defaultPagination = 1;
                this.$modal.hide('ghostmodal')
            }
        },
        isBegining: function() {
            if (this.$refs.carousel) {
                return this.$refs.carousel.swiper.isBeginning === true ? false : true
            } else {
                return false
            }
        },
        isLast: function(index) {
            if (this.$refs.carousel) {
                let total = this.ancestors.length
                let lastslide = this.ancestors[this.ancestors.length - 1] && this.ancestors[this.ancestors.length - 1].sample && this.ancestors[this.ancestors.length - 1].sample.length > 0 ? false : true
                return this.$refs.carousel.swiper.isEnd === true || index === this.ancestors.length - 2 && lastslide  ? true : false
            } else {
                return true
            }
        },
        showGen: function(index) {

            let gen = this.ancestors[index].generation && this.generations[this.ancestors[index].generation] ? this.generations[this.ancestors[index].generation] : this.ancestors[index].generation > 3 ? `${1 * (this.ancestors[index].generation) - 2}X Great Grand Parent` : "";
            return gen
        },
        showResults: function(evt) {
            console.log(this.ancestors[evt])
        },
        show: function(params) {
            var w = this;
            var title = params.title ? params.title : 'Alert!'
            var text = params.text ? params.text : 'Message received...'
            var buttons = [{
                    title: 'Continue',
                    default: false, // Will be triggered by default if 'Enter' pressed.
                    handler: () => {
                        w.closable = true;
                        w.$modal.hide('dialog');
                        w.closeModal(true);
                    }
                },
                {
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('dialog');
                    } // Button click handler
                }
            ]
            this.$modal.show('dialog', {
                title: title,
                text: text,
                class: params.class ? params.class : undefined,
                buttons: buttons
            })
        },
        beforeOpen: function(evt) {
            this.$gtag.event('createGhost', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            this.saving = false;
            this.suspend = false;
        this.averaged = false 
        this.groupSamples = true
            this.groupJSON = evt.params.groupJSON
            this.baseArray = [];
            this.type = "1";
            this.sampleJSON = evt.params.sampleJSON
            this.ancestors = [{
                generation: 2,
                index: 0,
                pct: 1
            }]
        },
        addAncestry: function() {
            let index = this.ancestors.length;
            this.ancestors.push({
                index: index,
                generation: 2,
                pct: 1,
            })
            this.options.initialSlide = index;
            this.$refs.carousel.swiper.update()
            setTimeout(() => {
                this.$refs.carousel.swiper.slideTo(index);
            }, 0)
        },
        removeAncestry: function(index) {
            this.$refs.carousel.swiper.slidePrev(300, function() {})
            this.ancestors.splice(index, 1)
            this.$refs.carousel.swiper.update()
        },
        uniqueSampleName: function(value) {
            var index = this.initData.findIndex(sample => sample.sample === value)
            if (value.indexOf(' ') >= 0 || (index >= 0 && !this.formDisabled && !this.sampleDisabled)) {
                return false
            } else {
                return true
            }
        },
        customLabel({
            label,
            age,
            origin,
            v,
            outlier

        }) {
            if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                return (label.replace(/_/g, " ") + ' ( ' + age + ' ' + origin + ' )' + outlier).replace(/:/, ' ► ')
            } else {
                origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                return (label.replace(/_/g, " ") + outlier + origin).replace(/:/, ' ► ')
            }
        },
    },
    components: {
        [Button.name]: Button,
        [Card.name]: Card,
        [Switch.name]: Switch,
        [Radio.name]: Radio,
        [Checkbox.name]: Checkbox,
        [FormGroupInput.name]: FormGroupInput,
    },
}
